// extracted by mini-css-extract-plugin
export var archiveButtonColor = "dUEgS";
export var deleteButtonColor = "NLjWA";
export var mailListItemIsPinned = "s1De5";
export var markAsReadButtonColor = "ssAKK";
export var moveButtonColor = "XeV7I";
export var pinButtonColor = "iW_V0";
export var pinButtonFilledColor = "E3w8P";
export var pinFilledColor = "MWwjW";
export var visibilityHidden = "hLBV6";